import { CHAPTERS, STATS } from "../lib/data";
import { Reveal, Overline } from "./Reveal";

export const About = () => (
  <section id="about" data-testid="about-section" className="relative py-28 lg:py-40">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-4">
          <Reveal>
            <Overline>Our Philosophy</Overline>
            <h2 className="ff-display text-4xl md:text-5xl leading-[1.02] tracking-tight text-ink">
              A school built on two
              <span className="italic text-maroon"> great currents.</span>
            </h2>
            <p className="mt-6 text-muted-foreground text-ink/70 leading-relaxed max-w-sm">
              We do not ask a child to choose between heritage and progress. We
              teach them to carry both — with grace.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-8 lg:border-l lg:border-maroon/15 lg:pl-16">
          <div className="flex flex-col divide-y divide-maroon/12">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.no} delay={i * 0.1}>
                <div className="py-8 first:pt-0 grid grid-cols-[auto_1fr] gap-6 md:gap-10 group">
                  <span className="ff-display text-5xl md:text-6xl text-maroon/25 group-hover:text-saffron transition-colors duration-500 leading-none">
                    {c.no}
                  </span>
                  <div>
                    <h3 className="ff-display text-2xl md:text-3xl text-ink mb-3">
                      {c.title}
                    </h3>
                    <p className="text-ink/70 leading-relaxed max-w-xl font-light">
                      {c.body}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>

      <Reveal delay={0.1}>
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 border-t border-maroon/15">
          {STATS.map((s) => (
            <div key={s.label} className="py-8 px-2 border-b md:border-b-0 md:border-r last:border-r-0 border-maroon/12 text-center md:text-left">
              <div className="ff-display text-4xl md:text-5xl text-maroon">{s.value}</div>
              <div className="mt-2 text-xs uppercase tracking-[0.18em] text-ink/60">{s.label}</div>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
